import { useCurrentOrg } from '@/modules/current-org/api';
import useHasPermissions from '@/modules/current-user/permissions';
import { getAvailableModes, type AvailableMode } from '../modeAvailability';

export type { AvailableMode };

// The modes an org can switch between, in display order (federated, client,
// supplier), derived from the shared getAvailableModes helper so the switcher
// and the default-mode resolver stay in lockstep.
export function useAvailableModes() {
  const { currentOrg } = useCurrentOrg();
  const { hasClientPermissions, hasSupplierPermissions, hasFederatedPermissions } =
    useHasPermissions();

  const availableModes = computed<AvailableMode[]>(() => {
    const org = currentOrg.value;
    if (!org) return [];

    return getAvailableModes(org, {
      client: hasClientPermissions.value,
      supplier: hasSupplierPermissions.value,
      federated: hasFederatedPermissions.value,
    });
  });

  return { availableModes };
}
